import { useQuery } from "@tanstack/react-query"
import { getVcms } from "../api/vcms"

export const useVcmsQuery = () => {
  return useQuery({
    queryKey: ["vcms"],
    queryFn: () => getVcms(),
  })
}